module.exports = __webpack_public_path__ + "media/images/sale_crm/accounts-5abc1825927e9fe742336f4e1ff2ff94.svg";